/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, Dec 2021
 * @flow
 */

import React from 'react';
import classNames from 'classnames';
import MergedTable from '../MergedTable';
import tableMergeEnum from '../../../../enums/tableMergeEnum';
import classes from './Body.module.css';

const LeftSection = props => {
  return (
    <div className={classes.leftSection}>
      {props?.stationView ? <StationsView {...props} /> : <EmployeesView {...props} />}
    </div>
  );
};

export default LeftSection;

const StationsView = props => {
  const {
    stations,
    station,
    setStationOrEmployee,
    tableWithSensors,
    sensorsObject,
    assigned,
    revenueCentersMap,
  } = props;

  const isVisible = table => {
    const { station, employees } = table;
    let sensorFlag = true, assignedFlag = true;

    if (tableWithSensors) {
      sensorFlag = (station.id && sensorsObject.hasOwnProperty([station.id])) ? true : false;
    }

    if (assigned) {
      assignedFlag = (Array.isArray(employees) && employees.length > 0);
    }

    return (sensorFlag && assignedFlag);
  };

  return (
    stations.map(eachTable => {
      const table = eachTable.station;
      const employees = Array.isArray(eachTable.employees) ? eachTable.employees : [];
      return (!isVisible(eachTable) ? null :
        <div key={table.id} className={classNames({ [classes.tableGroup]: true, [classes.group]: employees.length > 0 })}>
          <MergedTable
            active={station && station?.station?.id === table?.id}
            minus={employees.length > 0}
            station={eachTable}
            employee={employees[0]}
            name={table?.number}
            onClick={(pStation, employee, actionType) => setStationOrEmployee(pStation, employee, actionType, tableMergeEnum.STATION)}
            flexBasis={'13.2%'}
            isStationView
            revenueCentersMap={revenueCentersMap}
          />
          {employees.map(employee =>
            <MergedTable
              key={employee.id}
              minus={true}
              isEmployee
              name={employee.firstName}
              station={eachTable}
              employee={employee}
              onClick={(cStation, employee, actionType) => setStationOrEmployee(cStation, employee, actionType, tableMergeEnum.EMPLOYEE)}
              flexBasis={'20%'}
            />
          )}
        </div>
      )
    })
  );
};

const EmployeesView = props => {
  const {
    employee,
    employees,
    setStationOrEmployee,
    excludeTerminated,
    jobAllowsAssignment,
    jobsMap,
    assigned,
    revenueCentersMap
  } = props;

  const isVisible = employeeObj => {
    const { employee, stations } = employeeObj;
    let terminatedFlag = true, jobTypeFlag = true, jobAllowsAssignmentFlag = true, assignedFlag = true;

    if (excludeTerminated) { //show only employees where terminated = false
      terminatedFlag = employee.terminated === false;
    }

    if (jobAllowsAssignment) { //show employees that have a job and job.allowEmployeeTableAssignment is true
      const empJob = jobsMap.has(employee.jobId) ? jobsMap.get(employee.jobId) : {};
      jobAllowsAssignmentFlag = empJob?.allowEmployeeTableAssignment === true ? true : false;
    }

    if (assigned) {
      assignedFlag = (Array.isArray(stations) && stations.length > 0);
    }

    return (terminatedFlag && jobAllowsAssignmentFlag && jobTypeFlag && assignedFlag);
  };

  return (
    employees.map(eachEmployee => {
      const employeeObj = eachEmployee.employee;
      const stations = Array.isArray(eachEmployee.stations) ? eachEmployee.stations : [];
      return (!isVisible(eachEmployee) ? null :
        <div key={employeeObj.id} className={classNames({ [classes.tableGroup]: true, [classes.group]: stations.length > 0 })}>
          <MergedTable
            active={employee && employee?.employee?.id === employeeObj?.id}
            minus={stations.length > 0}
            employee={eachEmployee}
            isEmployee
            name={employeeObj.firstName}
            onClick={(pStation, employee, actionType) => setStationOrEmployee(pStation, employee, actionType, tableMergeEnum.EMPLOYEE)}
            flexBasis={'20%'}
            isEmployeeView
          />
          {stations.map(station =>
            <MergedTable
              key={station.id}
              minus={true}
              employee={eachEmployee}
              station={station}
              name={station?.number}
              onClick={(cStation, employee, actionType) => setStationOrEmployee(cStation, employee, actionType, tableMergeEnum.STATION)}
              flexBasis={'13.2%'}
              revenueCentersMap={revenueCentersMap}
            />
          )}
        </div>
      )
    })
  );
};
